"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FuzzySearchResult = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _fuzzysort = _interopRequireDefault(require("fuzzysort"));
var _react = _interopRequireDefault(require("react"));
var _typographyConstants = require("../../../typography/constants/typographyConstants");
const FuzzySearchResult = props => {
  const {
    optionToString,
    option,
    inputValue
  } = props;
  const optionAsString = optionToString(option);
  let optionLabel = [optionAsString];
  const result = _fuzzysort.default.single(inputValue, optionAsString);
  if (result) {
    optionLabel = result.highlight((match, index) => /*#__PURE__*/_react.default.createElement(FuzzySearchMatchStyled, {
      key: index
    }, match));
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, optionLabel);
};
exports.FuzzySearchResult = FuzzySearchResult;
const FuzzySearchMatchStyled = (0, _styled.default)("span")`
    font-weight: ${_typographyConstants.fontWeight.extraBold};
`;
//# sourceMappingURL=FuzzySearchResult.js.map